export enum LayoutType {
	ROOT_CLASS = 'OT_root',
}